export default __webpack_public_path__ + "static/media/9.bb4de361.png";